import styled from "@emotion/styled";

import { Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { LinkButton } from "@/components/pieces/link/LinkButton";

export const DarkBanner = styled(Flex)`
  background: radial-gradient(
    87.5% 87.5% at 50.06% 50%,
    #${IS_EXEC ? "003881" : "413393"} 0%,
    #2d2750 100%
  );
`;

export const BannerButton = styled(LinkButton)`
  height: 50px;
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 18;
  padding: 13px 20px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: none;
    color: #fff;
  }

  @media screen and (max-width: ${breakpoints.sm - 1}px) {
    width: 100%;
  }
`;
